export const FIELDS = {

  ID: 'id',
  COMPANY_ID: 'companyId',
  SOURCE_ID: 'sourceId',
  REFERENCE_ID: 'referenceId',
  RMAID: 'rmaId',
  VENDOR_RMAID: 'vendorRmaId',
  SALES_ORDER_ID: 'salesOrderId',
  INVOICE_ID: 'invoiceId',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PAYMENT_ID: 'paymentId',
  AMOUNT: 'amount',
  APPLIED: 'applied',
  BALANCE: 'balance',
  COMMENT: 'comment',
  IS_REFUND: 'isRefund',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  COMPANY_NAME: 'companyName',
  SOURCE_NAME: 'sourceName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  SODATE: 'soDate',
  CUSTOMER_PO: 'customerPo',
  PODATE: 'poDate',
};